import { useState } from 'react';
import { rawIssue, rawReceive, type DealRef, type RawTile } from './logistics-api';

// Движение по складу с точным количеством и (для списания) привязкой к сделке.
// Быстрые ± на карточке остаются для шага по единице; это окно — для реальных чисел.
export function StockMoveModal({
  raw,
  deals,
  dir,
  onClose,
  onDone,
}: {
  raw: RawTile;
  deals: DealRef[];
  dir: 'receive' | 'issue';
  onClose: () => void;
  onDone: () => void;
}) {
  const [direction, setDirection] = useState<'receive' | 'issue'>(dir);
  const [qty, setQty] = useState<string>(String(raw.step));
  const [dealId, setDealId] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const n = Number(qty);
  const valid = Number.isFinite(n) && n > 0;

  async function submit() {
    if (!valid) return;
    setBusy(true);
    setMsg(null);
    try {
      const body = { qty: n, deal_id: dealId ? Number(dealId) : null };
      await (direction === 'receive' ? rawReceive(raw.id, body) : rawIssue(raw.id, body));
      onDone();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Не удалось провести движение.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">Движение по складу</div>
            <div className="m-no">
              {raw.name} · остаток {raw.qty} {raw.unit}
            </div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <button
              className={'btn sm' + (direction === 'receive' ? '' : ' ghost')}
              disabled={busy}
              onClick={() => setDirection('receive')}
            >
              ＋ Приход
            </button>
            <button
              className={'btn sm' + (direction === 'issue' ? '' : ' ghost')}
              disabled={busy}
              onClick={() => setDirection('issue')}
            >
              − Списание
            </button>
          </div>

          <label className="fld">
            <span className="fld-l">Количество, {raw.unit}</span>
            <input
              type="number"
              min="0"
              step="any"
              value={qty}
              disabled={busy}
              autoFocus
              onChange={(e) => setQty(e.target.value)}
            />
          </label>

          <label className="fld">
            <span className="fld-l">
              {direction === 'issue' ? 'Списать на сделку' : 'Приход под сделку'}
            </span>
            <select value={dealId} disabled={busy} onChange={(e) => setDealId(e.target.value)}>
              <option value="">— без привязки —</option>
              {deals.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.no}
                </option>
              ))}
            </select>
          </label>

          {direction === 'issue' && n > raw.qty && (
            <p className="muted small" style={{ marginBottom: 10 }}>
              Списание больше остатка — спишется весь остаток ({raw.qty} {raw.unit}), в минус не
              уйдёт.
            </p>
          )}

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button className="btn sm" disabled={busy || !valid} onClick={submit}>
              {busy ? 'Проводим…' : direction === 'receive' ? 'Оприходовать' : 'Списать'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
